// extracted by mini-css-extract-plugin
module.exports = {"root":"DallasSelectPopover_root__jpFv_","modal":"DallasSelectPopover_modal__EkUw6","card":"DallasSelectPopover_card__33_1O"};